export default "__VITE_PUBLIC_ASSET__0afb3e7e__"